import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col justify-center items-end"
}
const _hoisted_2 = { class: "flex flex-wrap items-center mb-x1" }
const _hoisted_3 = { class: "whitespace-nowrap o-text-h3" }
const _hoisted_4 = { class: "whitespace-nowrap o-text-body ml-x1" }
const _hoisted_5 = {
  key: 1,
  class: "flex flex-wrap justify-end items-end"
}
const _hoisted_6 = { class: "whitespace-nowrap mr-x1 o-text-h3" }
const _hoisted_7 = { class: "whitespace-nowrap line-through mr-x1 o-text-body mb-2 lg:mb-4" }
const _hoisted_8 = { class: "sr-only" }
const _hoisted_9 = { class: "o-text-caption px-8 py-4 bg-brandy mb-2 lg:mb-4" }
const _hoisted_10 = {
  key: 2,
  class: "mb-x1 font-bold"
}


import { ProductDiscountType, ProductPriceModel } from '@/types/productServerApi';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';
import BlockLabelWithNamedArguments from '@/shared/BlockLabelWithNamedArguments.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WishListItemDiscount',
  props: {
    price: null
  },
  setup(__props: any) {



const globalLabels = useGlobalLabels(GlobalLabels.product);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.price.discount?.type === _unref(ProductDiscountType).MyBoliaBoost)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(__props.price.salesPrice.amount), 1),
            (_openBlock(), _createElementBlock("div", {
              key: __props.price.discount.percentage,
              class: "o-text-caption px-8 h-24 bg-brandy ml-x2 flex items-center"
            }, [
              _createElementVNode("div", null, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(globalLabels).myBoliaDiscount, { discount: __props.price.discount.percentage })), 1)
            ]))
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(__props.price.listPrice.amount) + " ", 1),
            _createElementVNode("span", null, _toDisplayString(_unref(globalLabels).nonMemberDiscountText), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.price.discount?.type === _unref(ProductDiscountType).Campaign)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(__props.price.salesPrice.amount), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(`${_unref(globalLabels).previousListPrice}:`), 1),
            _createTextVNode(" " + _toDisplayString(__props.price.listPrice.amount), 1)
          ]),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$dictionary.formatNamed(_unref(globalLabels).discount, { discount: __props.price.discount?.percentage ?? '' })), 1)
        ]))
      : _createCommentVNode("", true),
    (__props.price.discount?.expiryLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (__props.price.discount.expiryLabel)
            ? (_openBlock(), _createBlock(BlockLabelWithNamedArguments, {
                key: 0,
                label: __props.price.discount.expiryLabel
              }, null, 8, ["label"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})